export default "__VITE_ASSET__APTSaUvK__"